export enum WorkshopEventType {
  onlineWorkshop = 'onlineWorkshop',
  physicalEvent = 'physicalEvent',
  original = 'original',
}
